import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=8356c17c&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8356c17c')) {
      api.createRecord('8356c17c', component.options)
    } else {
      api.reload('8356c17c', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=8356c17c&", function () {
      api.rerender('8356c17c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HhNIENO9CX6e/JS/comp/FavElement.vue"
export default component.exports